/**
 * DOM Updater - Aggiornamenti DOM in risposta a cambiamenti stato
 */

import { $, setDataAttr } from '../utils/dom.js';
import { formatTime } from '../utils/format.js';

export class DOMUpdater {
  constructor(shadowRoot) {
    this.shadowRoot = shadowRoot;
  }
  
  /**
   * Aggiorna bottone play/pause
   * @param {boolean} isPlaying - Stato playing
   */
  updatePlayButton(isPlaying) {
    const container = $(this.shadowRoot, '.sasha-container');
    if (container) {
      // Rimuovi entrambe le classi prima
      container.classList.remove('playing', 'paused');
      
      // Aggiungi quella corretta
      if (isPlaying) {
        container.classList.add('playing');
      } else {
        container.classList.add('paused');
      }
    }
  }
  
  /**
   * Aggiorna progress bar
   * @param {number} currentTime - Tempo corrente
   * @param {number} duration - Durata totale
   */
  updateProgress(currentTime, duration) {
    const progressFill = $(this.shadowRoot, '#progress-fill');
    const currentTimeEl = $(this.shadowRoot, '#current-time');
    
    if (progressFill) {
      const percentage = (currentTime / duration) * 100;
      progressFill.style.width = `${percentage}%`;
    }
    
    if (currentTimeEl) {
      currentTimeEl.textContent = formatTime(currentTime);
    }
  }
  
  /**
   * Aggiorna durata
   * @param {number} duration - Durata
   */
  updateDuration(duration) {
    const durationEl = $(this.shadowRoot, '#duration');
    if (durationEl) {
      durationEl.textContent = formatTime(duration);
    }
  }
  
  /**
   * Aggiorna messaggio di stato
   * @param {string} message - Messaggio
   */
  updateStatus(message) {
    const statusEl = $(this.shadowRoot, '#status');
    if (statusEl) {
      statusEl.textContent = message;
      statusEl.style.display = message ? 'block' : 'none';
    }
  }
  
  /**
   * Aggiorna stato loading
   * @param {boolean} isLoading - Stato loading
   */
  updateLoadingState(isLoading) {
    const container = $(this.shadowRoot, '.sasha-container');
    if (container) {
      if (isLoading) {
        container.classList.add('loading');
      } else {
        container.classList.remove('loading');
      }
    }
  }
  
  /**
   * Aggiorna volume slider
   * @param {number} volume - Volume 0-1
   * @param {boolean} isMuted - Stato muted
   */
  updateVolumeSlider(volume, isMuted) {
    const slider = $(this.shadowRoot, '#volume-slider');
    if (slider) {
      slider.value = isMuted ? 0 : volume * 100;
    }
  }
  
  /**
   * Aggiorna stato mute
   * @param {boolean} isMuted - Stato muted
   */
  updateMuteState(isMuted) {
    setDataAttr(this.shadowRoot, '.sasha-container', 'data-muted', isMuted ? 'true' : null);
  }
}

